<side-panel-header [title]="'Get Support' | translate" />
<side-panel-content class="pt-sm">
  <sb-tab-group [selectedIndex]="0">
    <sb-tab [title]="'Learn' | translate">
      <learn-tab />
    </sb-tab>
    <sb-tab [title]="'Support' | translate">
      <sb-support-content (openOnboarding)="openChecklist()" />
    </sb-tab>
  </sb-tab-group>
</side-panel-content>
